import * as React from "react";
import { MediaQuery, Modal, Button, RichTextArea } from "@grandvisionhq/common";
import { Hr } from "@grandvisionhq/elements";
import { Text, H3 } from "@grandvisionhq/iris-ui";
/* empty css                                                                              */
const DeliveryIndicatorModal = ({ deliveryInfo, isModalOpen, onModalClose }) => {
  const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
  const { items = [], description, link, linkHint, title } = deliveryInfo;
  return /* @__PURE__ */ React.createElement(
    Modal,
    {
      className: "delivery-modal",
      isOpen: isModalOpen,
      onModalClose,
      showIcon: true,
      title,
      footer: link && /* @__PURE__ */ React.createElement(React.Fragment, null, linkHint && /* @__PURE__ */ React.createElement(Text, null, linkHint), /* @__PURE__ */ React.createElement(
        Button,
        {
          caption: link.label,
          href: link.url,
          hrefTarget: link.target === "external" ? "_blank" : void 0,
          size: "large"
        }
      ))
    },
    /* @__PURE__ */ React.createElement("div", { className: "delivery-modal__container" }, description && /* @__PURE__ */ React.createElement(RichTextArea, { className: "delivery-modal__description", content: description }), items.map(({ description: description2, id, image, price, title: title2 }) => {
      const heading = `${title2}${title2 && price ? " · " : ""}${price}`;
      return /* @__PURE__ */ React.createElement("div", { key: id, className: "delivery-modal-item" }, /* @__PURE__ */ React.createElement(Hr, { className: "delivery-modal-item__horizontal-rule" }), /* @__PURE__ */ React.createElement("div", { className: "delivery-modal-item__header" }, /* @__PURE__ */ React.createElement(H3, { variant: "heading-small" }, heading)), /* @__PURE__ */ React.createElement("div", { className: "delivery-modal-item__content" }, image && /* @__PURE__ */ React.createElement("div", { className: "delivery-modal-item__image-container" }, /* @__PURE__ */ React.createElement(
        "img",
        {
          className: "delivery-modal-item__image",
          src: isSmallScreen ? image.mobile.url : image.original.url,
          alt: image.alt,
          width: isSmallScreen ? image.mobile.dimensions.w : image.original.dimensions.w,
          height: isSmallScreen ? image.mobile.dimensions.h : image.original.dimensions.h
        }
      )), description2 && /* @__PURE__ */ React.createElement(
        RichTextArea,
        {
          className: "delivery-modal-item__description",
          content: description2
        }
      )));
    }))
  );
};
export {
  DeliveryIndicatorModal,
  DeliveryIndicatorModal as default
};
//# sourceMappingURL=DeliveryIndicatorModal.js.map
